import script from "./RestorePassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./RestorePassword.vue?vue&type=script&setup=true&lang=ts"

import "./RestorePassword.vue?vue&type=style&index=0&id=f0286d3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0286d3e"]])

export default __exports__